document.addEventListener('turbolinks:load', function () {
    if ($('.v2_permit_applications-form-section').length === 0) {
        return false
    }

    $('.disable-form-trigger').on('click', function(e) {
        e.preventDefault();
    })

    // line item selection starts here
    $(document).on('change', '.select-line-item', function () {
        var lineItemQuestion = $(this).parent().siblings('.line-item-question')
        var numberInput = $(lineItemQuestion).find('input.wholeNumberField')
        if ($(this).is(':checked')) {
            $(lineItemQuestion).removeClass('d-none')
            numberInput.val(1)
            numberInput.addClass('requiredField')
        } else {
            $(lineItemQuestion).addClass('d-none')
            numberInput.val('')
            numberInput.removeClass('requiredField').removeClass('is-invalid').removeClass('error-field')
            numberInput.siblings('.required-field-error').remove()
            numberInput.siblings('.whole-number-error').remove()
        }
    })

    // prevent the quantity from being cleared while its line item is selected
    $(document).on('blur', '.line-item-question .wholeNumberField', function () {
        var field = $(this)
        if (field.val() === '' || field.val() === null || Number(field.val()) <= 0) {
            field.val(1)
            field.removeClass('is-invalid').removeClass('error-field')
            field.siblings('.required-field-error').remove()
        }
    })
    // line item selection ends here
});